import React from 'react';
import Game from './Game';
import { Button, ButtonGroup } from 'react-bootstrap';
const wP = require('react-chessground/dist/images/pieces/merida/wP.svg')
const bK = require('react-chessground/dist/images/pieces/merida/bK.svg')

class GameWithControls extends React.Component {
  state = {
    orientation: 'white',
    undoCounter: 0,
    resetCounter: 0,
    thinking: false,
    winner: null
  }

  setOrientation(value) {
    return () => this.setState({ orientation: value })
  }

  undoMove = () => {
    this.setState({
      undoCounter: this.state.undoCounter + 1,
      winner: null,
    })
  }

  reset = () => {
    this.setState({
      resetCounter: this.state.resetCounter + 1,
      winner: null,
    })
  }

  setThinking = (value) => {
    this.setState({ thinking: value })
  }

  setWinner = (value) => {
    if (!this.state.winner) {
      this.setState({ winner: value })
    }
  }

  log = (s) => console.log(s)

  render() {
    let backgroundImage = 
        this.state.winner
        ? (this.state.winner === 'w' ? `url(${wP})` : `url(${bK})`)
        : (this.state.thinking
           ? 'url("https://media.giphy.com/media/hQgJCEdGOEHa8/giphy.gif")'
           : null
          );
    return (
      <div style={{display: "flex", justifyContent: "center"}}>
        <Game
          orientation={this.state.orientation}
          undoCounter={this.state.undoCounter}
          resetCounter={this.state.resetCounter}
          setThinking={this.setThinking}
          setWinner={this.setWinner}
        />
        <div style={{minWidth: "30px"}}></div>
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
          <div className="row" style={{margin: "10px"}}>
            <ButtonGroup>
              <Button
                onClick={this.setOrientation('white')}
                active={this.state.orientation === 'white'}>
                White
              </Button>
              <Button
                onClick={this.setOrientation('black')}
                active={this.state.orientation === 'black'}>
                Black
              </Button>
            </ButtonGroup>
          </div>
          <div style={{margin: "10px"}}>
            <Button onClick={this.undoMove}> Undo Move </Button>
          </div>
          <div style={{margin: "10px"}}>
            <Button onClick={this.reset}> Reset Game </Button>
          </div>
          <div style={{
            border: "1px solid rgb(195, 194, 194)",
            borderRadius: "5px",
            margin: "10px",
            padding: "5px",
          }}>
            <div>
              <div style={{textAlign: "center"}}>
                {
                  this.state.winner
                    ? `Winner: ${(this.state.winner === 'w') ? 'white' : 'black'}`
                  : this.state.thinking ? "Thinking..." : "Your move"
                }
              </div>
              <div
                className={
                  this.state.winner
                    ? (this.state.winner === 'w'
                       ? "white king"
                       : "black knight"
                      )
                  : null
                }
                style={{
                  display:"block",
                  width:"100px",
                  height:"100px",
                  zIndex: 100,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "100px 100px",
                  backgroundImage: backgroundImage,
                }}>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GameWithControls;
